// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSNewsList/index.less
// module id = 1131
// module chunks = 42